<template>
  <div>
    <el-dialog title="权限配置" :visible.sync="formVisible" width="1000px" :close-on-click-modal="false">
      <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="130px">
        <el-card class="box-card mt10">
          <el-descriptions title="权限配置"></el-descriptions>
          <el-form-item label="查看权限类型：" prop="authType" class="width100">
            <el-select v-model="form.authType" placeholder="请选择" clearable size="small" @change="handleAuthTypeChange">
              <el-option label="指定人查看" :value="2"></el-option>
              <el-option label="按身份查看" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <!-- 指定人查看 -->
          <div v-if="form.authType === 2">
            <el-form-item label="指定人查看：" class="width100">
              <div class="personnel-controls">
                <el-button type="primary" icon="el-icon-plus" @click="showAddPersonnelDialog = true">添加人员</el-button>
                <el-upload v-hasPermi="['meeting:record:import']" style="display: inline-block;margin:0 5px" :action="uploadImgUrl" :show-file-list="false" :http-request="uploadFile" :file-list="fileList">
                  <el-button size="mini" type="primary">导入名单</el-button>
                </el-upload>
                <el-button plain @click="handleDownloadTemplate">下载导入模版</el-button>
              </div>
              <el-table :data="list" style="width: 100%; margin-top: 10px;" size="small">
                <el-table-column prop="realName" label="人员姓名"></el-table-column>
                <el-table-column prop="userIdentity" label="身份"></el-table-column>
                <el-table-column prop="userPho" label="手机号"></el-table-column>
                <el-table-column label="操作" width="80">
                  <template slot-scope="{row}">
                    <el-button type="text" @click="handleDeleteSingle(row)">移除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </div>
          <!-- 按身份查看 -->
          <div v-if="form.authType === 1">
            <!-- key：弹窗关闭时子组件仍挂载，无 key 则不会再次执行 jurisd 的 created/initOptions -->
            <jurisd :key="`perm-jurisd-${jurisdKey}`" :form="form" title="查看身份权限" />
          </div>
        </el-card>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="formVisible = false">取消</el-button>
        <el-button type="primary" @click="doCreate()" v-if="form.authType === 1">确认</el-button>
      </div>
    </el-dialog>
    <!-- 添加人员弹窗 -->
    <el-dialog title="添加人员" :visible.sync="showAddPersonnelDialog" width="800px" :close-on-click-modal="false">
      <el-form ref="addPersonnelForm" :model="addPersonnelForm" label-width="120px" size="small">
        <el-form-item label="*指定人查看：">
          <div style="display: flex;">
            <el-select v-model="addPersonnelForm.levelType" placeholder="选择身份" @change="changeLevel" style="width: 200px; margin-right: 10px;">
              <el-option label="业务老师" :value="1"></el-option>
              <el-option label="技术老师" :value="2"></el-option>
              <el-option label="内部员工" :value="3"></el-option>
              <el-option label="加盟商" :value="4"></el-option>
              <el-option label="普通用户" :value="5"></el-option>
            </el-select>
            <el-select v-model="addPersonnelForm.selectedUser" value-key="userId" filterable remote placeholder="选择人员" :remote-method="searchUsers" :loading="loading" style="width: 100%;">
              <el-option v-for="item in options" :key="item.userId" :label="item.realName + '('+ item.levelName+')'" :value="item">
              </el-option>
            </el-select>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" >
        <el-button @click="showAddPersonnelDialog = false">取消</el-button>
        <el-button type="primary" @click="confirmAddPersonnel">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import templateClassificationApi from '@/api/marketing/templateClassification'
import templateClassificationAuthApi from '@/api/marketing/templateClassificationAuth'
import ImageUpload from "@/components/ImageUpload";
import Jurisd from './jurisd.vue'
import courseSubjectBarrierStudentApi from '@/api/course/courseSubjectBarrierStudent'
function initFormBean() {
  const formBean = {
    authType: null,
  }
  return formBean
}

export default {
  components: { ImageUpload, Jurisd },
  data() {
    return {
      uploadImgUrl: process.env.VUE_APP_BASE_API + '/sys/cosUploader/upload', // 上传的图片服务器地址
      form: initFormBean(),
      formVisible: false,
      showAddPersonnelDialog: false,
      addPersonnelForm: {
        levelType: null,
        selectedUser: null
      },
      formRules: {
        sourceType: [{ required: true, message: '请选择分类类别', trigger: 'change' }],
        name: [{ required: true, message: '请输入分类名称', trigger: 'blur' }],
        categoryLevel: [{ required: true, message: '请选择分类等级', trigger: 'change' }],
        orderNo: [{ required: true, message: '请选择分类等级', trigger: 'change' }, { pattern: /^[0-9]*$/, message: '必须为数字值', trigger: 'blur' }],
        state: [{ required: true, message: '请选择状态', trigger: 'change' }],
        authType: [{ required: true, message: '请选择查看权限类型', trigger: 'change' }],
      },
      isRepSub: false,
      sourceTypeOptions: [
        { label: '分享物料', value: 1 },
        { label: '项目管理', value: 2 },
        { label: '顾客物料', value: 3 },
        { label: '案例展示', value: 4 },
        { label: '业务物料', value: 5 },
        { label: '品宣', value: 6 },
        { label: '皮科普药', value: 7 }
      ],
      options: [],
      loading: false,
      list: [],
      rowItem: null,
      /** 每次打开权限弹窗递增，强制 jurisd 重建以重新拉取身份列表并回填选中态 */
      jurisdKey: 0
    }
  },
  created() {
  },
  methods: {
    uploadFile(file) {
      let formData = new FormData();
      formData.append("file", file.file);
      templateClassificationAuthApi.importExcel(formData).then(res => {
        if (res.code === '0') {
          this.$message.success(res.msg || '操作成功')
          this.doQueryList({})
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    searchUsers(query) {
      if (query !== '') {
        this.loading = true;
        // 模拟远程搜索，实际应用中应该是发起AJAX请求
        setTimeout(() => {
          this.loading = false;
          const levelType = this.addPersonnelForm.levelType || this.form.levelType;
          courseSubjectBarrierStudentApi.fetchUsers({ keyWords: query, type: levelType, pageNo: 1, pageSize: 100 }).then(data => {
            this.options = data.data.list;
          })
        }, 500);
      } else {
        this.options = [];
      }
    },
    changeLevel() {
      this.addPersonnelForm.selectedUser = null;
      this.options = []
    },
    handleAuthTypeChange() {
      // 切换权限类型时清空相关数据
      if (this.form.authType === 1) {
        this.form.userData = [];
      } else if (this.form.authType === 2) {
        this.form.authCustLevel = [];
        this.form.authTechLevel = [];
        this.form.isAuthInsider = false;
      }
    },
    // 添加人员相关方法
    confirmAddPersonnel() {
      if (!this.addPersonnelForm.levelType) {
        this.$message.warning('请选择身份');
        return;
      }
      if (!this.addPersonnelForm.selectedUser) {
        this.$message.warning('请选择人员');
        return;
      }

      // 检查是否已存在
      const exists = this.list.some(user => user.userId === this.addPersonnelForm.selectedUser.userId);
      console.log(111, exists, this.addPersonnelForm.selectedUser)
      if (exists) {
        this.$message.warning('该人员已存在');
        return;
      }
      let { levelId, userId } = this.addPersonnelForm.selectedUser;
      const mapLevelSource = { 1: 1, 2: 2, 3: 3, 4: 1, 5: 1 }
      const levelSource = mapLevelSource[this.addPersonnelForm.levelType] || 1
      let params = {
        classificationId: this.form.classificationId,
        levelId,
        levelSource,
        userId
      }
      templateClassificationAuthApi.create(params).then(res => {
        if (res.code === '0') {
          // 重置表单
          this.addPersonnelForm = {
            levelType: null,
            selectedUser: null
          };
          this.showAddPersonnelDialog = false;
          this.options = [];
          this.doQueryList()

        }
      })
      // 添加到列表
      // this.list.push({
      //   ...this.addPersonnelForm.selectedUser,
      //   userIdentity: this.addPersonnelForm.selectedUser.levelName,
      //   levelName: this.getLevelName(this.addPersonnelForm.levelType)
      // });


    },
    getLevelName(levelType) {
      const levelMap = {
        1: '业务老师',
        2: '技术老师',
        3: '内部员工',
        4: '加盟商',
        5: '普通用户'
      };
      return levelMap[levelType] || '';
    },
    // 导入名单
    handleImportList() {
      this.$message.info('导入名单功能待实现');
    },
    // 下载导入模版
    handleDownloadTemplate() {
      templateClassificationAuthApi.downloadExcelTemplate().then(() => {
        this.$message.success('下载成功');
      }).catch(error => {
        this.$message.error(error.message || '下载失败，请重试');
      })
    },
    /**
     * 重置表单
     */
    resetForm() {
      this.form = initFormBean()
    },
    handleUpdate(row) {
      this.rowItem = {...row}
      this.resetForm()
      this.jurisdKey += 1
      this.form = {
        classificationId: row.id,
        authType: row.authType,
        userDataList: row.userDataList,
        levelDataList: row.levelDataList,
        // 列表接口保存后常只带 levelData 字符串，不带 levelDataList，需一并传入供 jurisd 解析
        levelData: row.levelData
      }
      if (row.authType === 2) this.doQueryList()
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    doQueryList() {
      let { classificationId } = this.form;
      templateClassificationAuthApi.fetchList({ classificationId }).then(({ data }) => {
        this.list = data;
      })
    },
    calcParams() {
      let params = JSON.parse(JSON.stringify(this.form))
      // 仅在按身份时组装 levelData
      const levelData = []
      if (params.authType === 1) {
        if (Array.isArray(this.form.authCustLevel)) {
          const custIds = this.form.authCustLevel
            .filter(item => item.isActive)
            .map(item => item.key)
          if (custIds.length > 0) {
            levelData.push({ levelSource: 1, levelIds: custIds.join(',') })
          }
        }
        if (Array.isArray(this.form.authTechLevel)) {
          const techIds = this.form.authTechLevel
            .filter(item => item.isActive)
            .map(item => item.key)
          if (techIds.length > 0) {
            levelData.push({ levelSource: 2, levelIds: techIds.join(',') })
          }
        }
        if (this.form.isAuthInsider) {
          // 内部员工开启时，传递一个标识
          levelData.push({ levelSource: 3, levelIds: '0' })
        }
        return JSON.stringify(levelData)
      }
    },
    /**
     * 执行新建操作
     */
    doCreate() {
      let params = JSON.parse(JSON.stringify(this.rowItem))
      params.authType = this.form.authType;
      params.levelData = this.calcParams()
      delete params.levelDataList
      delete params.userDataList
      delete params.childList
      delete params.createdTime
      delete params.operatedTime
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          if (this.isRepSub) return
          this.isRepSub = true
          templateClassificationApi.update(params).then((data) => {
            this.postCallback(data)
          }).catch(res => {
            this.isRepSub = false
          });
        }
      });
    },
    postCallback(response) {
      this.isRepSub = false
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
    },
    handleDeleteSingle(row) {
      return this.$common.confirm('是否确认删除')
        .then(() => templateClassificationAuthApi.deleteById(row.id))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-select {
  width: 100%;
}
/* 保证选中态(primary)按钮也为朴素样式 */
::v-deep .el-button--primary.is-plain {
  background-color: #fff !important;
  border-color: #409eff !important;
  color: #409eff !important;
}
::v-deep .el-button--primary.is-plain:focus,
::v-deep .el-button--primary.is-plain:hover {
  background-color: #ecf5ff !important;
  border-color: #409eff !important;
  color: #409eff !important;
}

.personnel-controls {
  margin-bottom: 10px;

  .el-button {
    margin-right: 10px;
  }
}

/* 表格样式优化 */
::v-deep .el-table {
  .el-table__header {
    th {
      background-color: #f5f7fa;
      color: #606266;
      font-weight: 500;
    }
  }

  .el-table__body {
    tr:hover {
      background-color: #f5f7fa;
    }
  }
}

/* 弹窗样式 */
::v-deep .el-dialog__body {
  padding: 20px;
}

/* 添加人员弹窗中的选择器样式 */
::v-deep .el-form-item__content {
  .el-select {
    margin-right: 10px;
  }
}
</style>
